var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBoolean)?_c('i',{class:_vm.booleanIcon}):_c('span',[(_vm.isIcon)?_c('i',{class:_vm.iconClass}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.formatedValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }